import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";
import { InputRoot } from "./InputRoot";

export const InputText = forwardRef(
  (
    props: InputHTMLAttributes<HTMLInputElement>,
    ref: ForwardedRef<HTMLInputElement>,
  ) => <InputRoot {...props} ref={ref} />,
);

InputText.displayName = "InputText";
